<template>
<div class="product-links-div shop" v-if="getProductsWithHelp.length">
    <div data-delay="4000" data-animation="slide" class="shop-slider w-slider" data-autoplay="false" data-easing="ease" data-hide-arrows="false" data-disable-swipe="false" data-autoplay-limit="0" data-nav-spacing="3" data-duration="500" data-infinite="true" role="region" aria-label="carousel">
        <div class="mask-3 w-slider-mask add_bottom-padding" id="w-slider-mask-0">
            <!-- Display all slides -->
            <div v-for="(product, index) in getProductsWithHelp" :key="product.sku" class="product-box-slide w-slide" role="group" :aria-label="`${index + 1} of ${totalSlides}`" :style="slideStyles(index)" :aria-hidden="index < currentSlide || index >= currentSlide + itemsPerSlide">
                <div class="product-preview-div" :aria-hidden="index < currentSlide || index >= currentSlide + itemsPerSlide">
                    <ProductCard v-if="product.element_type === 'product'" :product="product" :page="'shop'" :index="index"></ProductCard>
                    <HelpCard :category="category" v-else></HelpCard>
                </div>
            </div>
        </div>
        <!-- Navigation Arrows -->
        <div class="slider-controls">
            <div class="left-arrow-hide w-slider-arrow-left" role="button" @click="previousSlide" tabindex="0" aria-controls="w-slider-mask-0" aria-label="previous slide">
                <div class="icon-27 w-icon-slider-left"></div>
            </div>
            <div class="right-arrow-7 w-slider-arrow-right" role="button" @click="nextSlide" tabindex="0" aria-controls="w-slider-mask-0" aria-label="next slide">
                <div class="icon-27 w-icon-slider-right"></div>
            </div>
        </div>
        <!-- Navigation Dots -->
        <div class="slide-nav-5 w-slider-nav w-slider-nav-invert w-round">
            <div v-for="n in totalPages" :key="n" :class="['w-slider-dot', { 'w-active': currentPage === n - 1 }]" @click="goToPage(n - 1)" role="button" tabindex="0"></div>
        </div>
    </div>
</div>
</template>

    
    
<script>
import detectMobile from '@/utils/MobileDetection';

import {
    createUrlName
} from '@/utils/productData';
import {
    mapActions
} from 'vuex';
import ProductCard from './productCard.vue';
import HelpCard from './HelpCard.vue';
export default {
    name: 'ProductSlider',
    components: {
        ProductCard,
        HelpCard
    },
    props: {
        products: {
            type: Array,
            required: true,
            default: () => []
        },
        category: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            currentSlide: 0,
            isAnimating: false,
            slideWidth: 0
        };
    },

    computed: {
        itemsPerSlide() {
            if (this.isMobile) {
                return 2;
            }
            return 4;
        },
        getProductsWithHelp() {
            const slides = [];
            const productsCopy = [...this.products];
            productsCopy.forEach(element => {
                slides.push({
                    element_type: 'product',
                    ...element
                });

                if (slides.length % 3 === 0) {
                    slides.push({
                        element_type: 'help',
                    });
                }
            });
            if(slides.length<3 && slides.length>0){
                slides.push({
                        element_type: 'help',
                    });
            }
            return slides;
        },

        totalSlides() {
            return this.getProductsWithHelp.length;
        },

        slideStyles() {
            return (index) => {
                const isVisible = index >= this.currentSlide && index < this.currentSlide + this.itemsPerSlide;
                return {
                    transition: 'all, transform 500ms',
                    transform: `translateX(${-this.currentSlide * this.slideWidth}px)`,
                    opacity: isVisible ? 1 : 1,
                    'aria-hidden': !isVisible
                };
            };
        },

        currentPage() {
            return Math.floor(this.currentSlide / this.itemsPerSlide);
        },

        totalPages() {
            return Math.ceil(this.getProductsWithHelp.length / this.itemsPerSlide);
        },

        maxSlide() {
            return Math.max(0, this.getProductsWithHelp.length - this.itemsPerSlide);
        },

        ariaLiveText() {
            return `Slide ${this.currentPage + 1} of ${this.totalPages}.`;
        },
        isMobile() {
            return detectMobile()
        },
    },

    methods: {
        ...mapActions(['addToCart']),

        calculateDailyPrice(price) {
            return (parseFloat(price) / 30).toFixed(2);
        },

        createUrlName,

        getProductImage(name) {
            return `https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_images/webp/${name}1.webp`;
        },
        truncateDescription(description) {
            if (description && description.length > 60) {
                return description.slice(0, 60) + '...';
            }
            return description;
        },

        handleAddToCart(product) {

            // Create cart item explicitly
            const cartItem = {
                id: product.sku,
                name: product.product_name,
                category: product.category,
                price: product.discounted_price,
                retail_price: product.retail_price,
                subheader: product.shop_page_product_sub_header,
                quantity: 1,
                image: `https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_images/${product.image_pre_text}1.png`,
                main_type: product.main_type
            };

            this.$store.dispatch('addToCart', cartItem);
        },

        previousSlide() {
            if (this.currentSlide > 0 && !this.isAnimating) {
                this.isAnimating = true;
                this.currentSlide = Math.max(0, this.currentSlide - this.itemsPerSlide);
                this.handleTransitionEnd();
            } else {
                this.currentSlide = this.maxSlide;
            }
        },

        nextSlide() {
            if (this.currentSlide < this.maxSlide && !this.isAnimating) {
                this.isAnimating = true;
                this.currentSlide = Math.min(this.maxSlide, this.currentSlide + this.itemsPerSlide);
                this.handleTransitionEnd();
            } else {
                this.currentSlide = 0
            }
        },

        handleTransitionEnd() {
            setTimeout(() => {
                this.isAnimating = false;
            }, 500);
        },

        goToPage(pageIndex) {
            if (!this.isAnimating) {
                this.isAnimating = true;
                this.currentSlide = pageIndex * this.itemsPerSlide;
                this.handleTransitionEnd();
            }
        },

        updateSlideWidth() {
            const sliderMask = document.querySelector('.mask-3');
            if (sliderMask) {
                this.slideWidth = sliderMask.offsetWidth / this.itemsPerSlide;
            }
        },
        handleTouchStart(event) {
            this.startX = event.touches[0].clientX;
        },
        handleTouchMove(event) {
            this.endX = event.touches[0].clientX;
        },
        handleTouchEnd() {
            const swipeDistance = this.startX - this.endX;
            const swipeThreshold = 50; // Minimum distance to count as a swipe

            if (swipeDistance > swipeThreshold) {
                // Swipe left
                this.nextSlide();
            } else if (swipeDistance < -swipeThreshold) {
                // Swipe right
                this.previousSlide();
            }
        },
    },

    mounted() {
        this.updateSlideWidth();
        window.addEventListener('resize', this.updateSlideWidth);
        this.$el.addEventListener('touchstart', this.handleTouchStart);
        this.$el.addEventListener('touchmove', this.handleTouchMove);
        this.$el.addEventListener('touchend', this.handleTouchEnd);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.updateSlideWidth);
        this.$el.removeEventListener('touchstart', this.handleTouchStart);
        this.$el.removeEventListener('touchmove', this.handleTouchMove);
        this.$el.removeEventListener('touchend', this.handleTouchEnd);
    }
};
</script>
    
    
<style scoped>
@media screen and (max-width: 479px) {
    .spacer-for-page-linking {
        height: 12px !important;
    }

    .add_bottom-padding {
        padding-bottom: 30px !important;
    }
}
</style>
